import { useQuery } from "@tanstack/react-query";
import { getSearchKodeAsuransi, getSearchKodeBank, getSearchKodeGelar, getSearchKodeKota, getSearchKodeDnominasi, getSearchKodeNegara, getSearchKodePekerjaan, getSearchKodePemasok, getSearchKodePos, getSearchKodeValas, getSearchNasabah, getSearchNasabahTerkait, getSearchNasabahUtama, } from "../../services";
export const useGetSearchKodeKota = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodekota", searchParams],
        queryFn: () => getSearchKodeKota(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodePos = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodepos", searchParams],
        queryFn: () => getSearchKodePos(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodeBank = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodebank", searchParams],
        queryFn: () => getSearchKodeBank(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodeAsuransi = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodeasuransi", searchParams],
        queryFn: () => getSearchKodeAsuransi(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodePemasok = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodepemasok", searchParams],
        queryFn: () => getSearchKodePemasok(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodeGelar = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodegelar", searchParams],
        queryFn: () => getSearchKodeGelar(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodeValas = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodevalas", searchParams],
        queryFn: () => getSearchKodeValas(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodeDnominasi = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodednominasi", searchParams],
        queryFn: () => getSearchKodeDnominasi(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodePekerjaan = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodepekerjaan", searchParams],
        queryFn: () => getSearchKodePekerjaan(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchNasabah = (searchParams) => {
    return useQuery({
        queryKey: ["master", "nasabah", searchParams],
        queryFn: () => getSearchNasabah(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchKodeNegara = (searchParams) => {
    return useQuery({
        queryKey: ["master", "kodenegara", searchParams],
        queryFn: () => getSearchKodeNegara(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchNasabahUtama = () => {
    return useQuery({
        queryKey: ["master", "nasabah-relasi", "utama"],
        queryFn: getSearchNasabahUtama,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchNasabahTerkait = () => {
    return useQuery({
        queryKey: ["master", "nasabah-relasi", "terkait"],
        queryFn: getSearchNasabahTerkait,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
